export { default as ActivationPage } from './Activation'